var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MemberActivitySubmissionWrapper',{attrs:{"handleComplete":_vm.handleProfileUpdateComplete,"handleCancel":() => this.$router.back(),"completeText":"common.confirm"}},[_c('AccountCore')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }